module.exports = __webpack_public_path__ + "static/media/cerca_logo.fa9fe2fc.svg";


//////////////////
// WEBPACK FOOTER
// ./client/modules/ui/assets/cerca_logo.svg
// module id = 1254
// module chunks = 0